import confetti from 'canvas-confetti';
function calculateRandomConfettiAngle(angleMultiplier = 0) {
    const randomResult = Math.random() * 50;
    const angleResult = angleMultiplier * 30;
    return randomResult + angleResult + 30;
}
export function celebrate(count = 3) {
    for (let i = 0; i < count; i++) {
        setTimeout(() => {
            confetti({ angle: calculateRandomConfettiAngle(i) });
        }, 200 * i);
    }
}
